import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from "@mui/material";
import MainLogin from './pages/login/MainLogin';
import MainSidebar from './layout/MainSidebar';
import MainTopbar from './layout/MainTopbar';
import MainDashboard from './pages/dashboard/MainDashboard';
import CalendarList from './pages/calendar/CalendarList';
import CalendarEdit from './pages/calendar/CalendarEdit';
import PharmacyList from './pages/pharmacies/PharmacyList';
import PharmacyEdit from './pages/pharmacies/PharmacyEdit';
import PatientList from './pages/patients/PatientList';
import PatientEdit from './pages/patients/PatientEdit';
import DoctorList from './pages/doctors/DoctorList';
import DoctorEdit from './pages/doctors/DoctorEdit';
import { tokenKey } from './types';
import { ColorModeContext, useMode } from './theme';
import { AlertProvider } from './layout/MainAlert';

function App() {
  const [theme, colorMode] = useMode();
  const [loggedIn, setLoggedIn] = useState(false);
  const [currentPharmacy, setCurrentPharmacy] = useState<null | string>(null);

  useEffect(() => {
    const token = sessionStorage.getItem(tokenKey);
    if (!token) {
      setLoggedIn(false);
      return;
    }

    setLoggedIn(true);
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {loggedIn ? (
          <div className="app">
            <MainSidebar />
            <main className="content">
              <MainTopbar setCurrentPharmacy={setCurrentPharmacy} />
              <AlertProvider>
                <Routes>
                  <Route path="/dashboard" element={<MainDashboard currentPharmacy={currentPharmacy} />} />
                  <Route path="/calendar" element={<CalendarList currentPharmacy={currentPharmacy} />} />
                  <Route path="/calendar/:id" element={<CalendarEdit />} />
                  <Route path="/patients" element={<PatientList />} />
                  <Route path="/patients/:id" element={<PatientEdit />} />
                  <Route path="/doctors" element={<DoctorList />} />
                  <Route path="/doctors/:id" element={<DoctorEdit />} />
                  <Route path="/pharmacies" element={<PharmacyList />} />
                  <Route path="/pharmacies/:id" element={<PharmacyEdit />} />
                </Routes>
              </AlertProvider>
            </main>
          </div>
        ) : (
          <div className="app">
            <Routes>
              <Route path="/" element={<MainLogin setLoggedIn={setLoggedIn} />} />
            </Routes>
          </div>
        )}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;